export const userListActionsActive = [
	{
		label: 'Delete',
		value: 'delete',
	},
	{
		label: 'Deactivate',
		value: 'deactivate',
	},
	{
		label: 'Automated E-Mail reports',
		value: 'report',
	},
];

export const userListActionsInactive = [
	{
		label: 'Delete',
		value: 'delete',
	},
	{
		label: 'Activate',
		value: 'activate',
	},
];
